<script lang="ts">
	import { page } from '$app/state'
	import { ui } from '#library/stores.ts'
	import { onMount } from 'svelte'
	import { attrs } from '#library/attrs.ts'

	let { nano } = $props()

	let scrollY = $state(0)
	let prevScrollY = $state(0)
	let scrollingDown = $state(false)
	let compact = $state(false)
	let innerHeight = $state(0)
	let offsetHeight = $state(0)

	let links = $derived(page.data.layout?.quick_menu || [])
	let immersive = $state(page.url.pathname === '/')

	$effect(() => (immersive = $ui.immersive && scrollY < innerHeight - offsetHeight))

	function handleScroll() {
		prevScrollY = scrollY
		scrollY = window.scrollY
		scrollingDown = scrollY > prevScrollY
		compact = !nano && scrollY > 50 && scrollingDown
	}

	onMount(() => {
		scrollY = window.scrollY
		prevScrollY = window.scrollY
		window.addEventListener('scroll', handleScroll, { passive: true })
		return () => window.removeEventListener('scroll', handleScroll)
	})
</script>

<svelte:window bind:innerHeight />

<header class="head" class:compact class:nano class:immersive bind:offsetHeight {...attrs(page.data.layout)}>
	<div class="contain">
		<a class="logo" class:compact class:nano class:immersive href="/" aria-label="Home">
			<svg class="logo-icon" class:compact class:nano>
				<use xlink:href="/images/vector.svg#icon"></use>
			</svg>
			{#if !nano}
				<svg class="logo-word" class:compact>
					<use xlink:href="/images/vector.svg#logo"></use>
				</svg>
			{/if}
		</a>
		{#if nano}
			<a class="link nano" href="/" target="_blank">
				Visit Bedales
				<svg class="svg"><use xlink:href="/images/vector.svg#arrow-up-right"></use></svg>
			</a>
		{:else}
			<nav class="nav" class:compact>
				{#each links as item (item._uid)}
					<a class="link" href={item.link.url}>{item.link.text}</a>
				{/each}
			</nav>
			<button class="icon" class:compact aria-label="Search" onclick={() => ($ui.search = true)}>
				<svg class="svg"><use xlink:href="/images/vector.svg#search"></use></svg>
			</button>
			<button class="icon" aria-label="Menu" onclick={() => ($ui.menu = true)}>
				<svg class="svg"><use xlink:href="/images/vector.svg#burger"></use></svg>
			</button>
		{/if}
	</div>
</header>

<style land="css">
	.head {
		align-items: center;
		background-color: var(--c-white);
		color: var(--c-charcoal);
		display: flex;
		height: 3.875rem;
		position: fixed;
		top: 0;
		transition: all 0.5s ease;
		width: 100%;
		z-index: 3;

		@media (--from-mobile) {
			height: 6.9375rem;
		}

		&.immersive {
			background-color: transparent;
			color: var(--c-gimson);
		}

		&.compact {
			background-color: var(--c-badley);
			color: var(--c-white);

			@media (--from-mobile) {
				height: 4.25rem;
			}
		}

		&.nano {
			@media (--from-mobile) {
				height: 4.25rem;
			}
		}
	}

	.contain {
		align-items: center;
		display: flex;
		gap: 1rem;

		@media (--from-mobile) {
			gap: 2rem;
		}

		@media (--from-desktop) {
			gap: 3rem;
		}
	}

	.logo {
		color: var(--c-badley);
		flex: 0 0 auto;
		margin-inline-end: auto;

		&.immersive {
			color: var(--c-gimson);
		}

		&.compact,
		&.nano {
			color: var(--c-white);
			inset: auto auto auto 50%;
			position: absolute;
			translate: -50% 0;
		}

		&.nano {
			color: var(--c-badley);
		}
	}

	.logo-word {
		size: 1.5rem 6.25rem;

		@media (--from-mobile) {
			size: 2.9375rem 12.5rem;
		}

		&.compact {
			display: none;
		}
	}

	.logo-icon {
		display: none;
		size: 1.5rem;

		@media (--from-mobile) {
			size: 2.75rem;
		}

		&.compact,
		&.nano {
			display: block;
		}
	}

	.nav {
		display: none;

		@media (--from-tablet) {
			align-items: center;
			display: flex;
			margin-inline-start: auto;
			padding-inline: 1rem;
		}
	}

	.nav.compact {
		display: none;
	}

	.link {
		font: 500 var(--f-signpost);
		letter-spacing: var(--ls-signpost);
		padding: 0.75rem 1.25rem;
		text-transform: uppercase;
		white-space: nowrap;

		&.nano {
			align-items: center;
			color: var(--c-crocus);
			display: flex;
			font: 500 var(--f-body2);
			gap: 0.5rem;
			letter-spacing: var(--ls-body2);
			padding-inline: 0;
		}
	}

	.icon,
	.link {
		flex: 0 0 auto;

		&.compact,
		&.nano {
			margin-inline-start: auto;
		}
	}

	.svg {
		size: 1.625rem 2rem;

		@media (--from-mobile) {
			size: 1.75rem 2.125rem;
		}
	}
</style>
